import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { makeCall } from "../../../helpers/makeCall";
import { PastoralContext } from "../../../contexts/PastoralContext";
import { ProfileContext } from "./../../../contexts/ProfileContext";
import { convertSeconds, resolveRecordingUrl } from "../../../helpers/utils";
import Dialer from './dialer';
import {
  MdAccessTime,
  MdBusiness,
  MdDescription,
  MdLanguage,
  MdLocationOn,
  MdPhone,
  MdChurch,
} from "react-icons/md";
export const RecordingPlayBack = (props) => {
  const { isOnCall, setIsOnCall, setCallSettings } =
    useContext(PastoralContext);
    const {worker } = useContext(ProfileContext);

  const playback =
    props.playback.length < 1 || props.playback === undefined
      ? null
      : props.playback.find(call => call.direction === 'inbound');

  const [playbackState, setPlayback] = useState({
    user_number: playback ? playback.user_number : '',
    twilio_number: playback ? playback.twilio_number : ''
  });
  const [showDialer, setShowDialer] = useState(false);
  const [dialerNumber, setDialerNumber] = useState(playback ? playback.user_number : '');
  const [organizationInfo, setOrganizationInfo] = useState({
    name: '',
    location: '',
    phone: '',
    website: '',
    serviceStartTimes: '',
    denomination: '',
    description: ''
  });

  // MAKE AN OUTGOING CALL

  async function makeOutgoingCall() {
    setShowDialer(true);
   
  }
  const recordingUrl = playback
    ? resolveRecordingUrl(playback.recordings)
    : null;
  const organizationLookupPhone = playback?.twilio_number || playback?.user_number || dialerNumber || playbackState.twilio_number || playbackState.user_number;
  const shouldShowOrganizationInfo =
    organizationLookupPhone.replace(/\D/g, "") !== "18662734444";

  useEffect(() => {
    const phoneNumber = organizationLookupPhone;

    if (!phoneNumber || !process.env.REACT_APP_API_URL) {
      return;
    }

    const apiUrl = `${process.env.REACT_APP_API_URL}/lookup/organization-by-phone?phone=${encodeURIComponent(phoneNumber)}`;
var options = {
      method: "GET",

      headers: {
        "Content-Type": "application/json",
        Authorization: process.env.REACT_APP_API_AUTHORIZATION,
      },
    };
    fetch(apiUrl, options)
      .then((response) => response.json())
      .then((result) => {
        const data = result?.data ?? {};
        const location = [
          data.address,
          data.city,
          data.province,
          data.country,
          data.postal_code
        ]
          .filter(Boolean)
          .join(', ');

        setOrganizationInfo({
          name: data.name || data.Name || 'N/A',
          location: location || 'N/A',
          phone: data.twilio_number || phoneNumber,
          website: data.website || 'N/A',
          serviceStartTimes: data.service_start_times || 'N/A',
          denomination: data.denomination || 'N/A',
          description: data.description || 'N/A'
        });
      })
      .catch(() => {
        setOrganizationInfo({
          name: 'N/A',
          location: 'N/A',
          phone: phoneNumber,
          website: 'N/A',
          serviceStartTimes: 'N/A',
          denomination: 'N/A',
          description: 'N/A'
        });
      });
  }, [organizationLookupPhone]);

  return (
    playback &&
    recordingUrl && (
      <ContentRow>
        {shouldShowOrganizationInfo && <OrganizationInfoCard>
          <Header>
            <HeaderIcon><MdBusiness /></HeaderIcon>
            <HeaderText>ORGANIZATION INFORMATION</HeaderText>
          </Header>
          <InfoGrid>
            <InfoTile>
              <TileIcon><MdBusiness /></TileIcon>
              <InfoContent>
                <Label>ORGANIZATION</Label>
                <Value>{organizationInfo.name || "N/A"}</Value>
              </InfoContent>
            </InfoTile>
            <InfoTile>
              <TileIcon><MdPhone /></TileIcon>
              <InfoContent>
                <Label>PHONE</Label>
                <Value>{organizationInfo.phone || "N/A"}</Value>
              </InfoContent>
            </InfoTile>
            <InfoTile>
              <TileIcon><MdLanguage /></TileIcon>
              <InfoContent>
                <Label>WEBSITE</Label>
                <Value>{organizationInfo.website || "N/A"}</Value>
              </InfoContent>
            </InfoTile>
            <InfoTile>
              <TileIcon><MdChurch /></TileIcon>
              <InfoContent>
                <Label>DENOMINATION</Label>
                <Value>{organizationInfo.denomination || "N/A"}</Value>
              </InfoContent>
            </InfoTile>
          </InfoGrid>
          <InfoList>
            <InfoRow>
              <RowIcon><MdLocationOn /></RowIcon>
              <InfoContent>
                <Label>LOCATION</Label>
                <Value>{organizationInfo.location || "N/A"}</Value>
              </InfoContent>
            </InfoRow>
            <InfoRow>
              <RowIcon><MdAccessTime /></RowIcon>
              <InfoContent>
                <Label>HOURS</Label>
                <Value>{organizationInfo.serviceStartTimes || "N/A"}</Value>
              </InfoContent>
            </InfoRow>
            <InfoRow>
              <RowIcon><MdDescription /></RowIcon>
              <InfoContent>
                <Label>DESCRIPTION</Label>
                <DescriptionValue>{organizationInfo.description || "N/A"}</DescriptionValue>
              </InfoContent>
            </InfoRow>
          </InfoList>
        </OrganizationInfoCard>}

        <Wrapper>
          <div className="flex flex-row m-4 mb-0">
            <span className="bg-marina rounded-full w-10 h-10 block">
              <img
                src={require("./../../../assets/images/PhoneTransfer.png")}
                alt="Call recording"
                width="48"
              />
            </span>
            <div className="justify-between w-full flex">
              <div className="flex flex-col pl-2">
                <Heading>CALL RECORDING</Heading>
                <DetailsSpan className="gap-3 flex">
                  <span className="text-ikura py-2">   {props.username} </span>
                 <span className="text-ikura py-2"> {playbackState.user_number || playback?.user_number} </span>
                  <span className=" py-2">{convertSeconds(playback.duration).hours+':'+convertSeconds(playback.duration).minutes+':'+convertSeconds(playback.duration).seconds} </span>
                </DetailsSpan>
              </div>
            { props.call_details.status!== '2' && !props.call_details.dont_call_back && <button disabled={isOnCall} onClick={(e) => makeOutgoingCall()}>
                {" "}
                CALL BACK NOW
              </button>}
            </div>
          </div>

          <Recording
            controls
            className="m-4 w-11/12 p-0"
            src={recordingUrl}
            type="audio/ogg"
          >
            Your browser does not support the audio element.
          </Recording>
          {showDialer && (
            <Dialer
              onClose={() => setShowDialer(false)}
              onCall={() => {
                props.call_details.user_number = dialerNumber;
                makeCall(dialerNumber, setIsOnCall, props.call_details,worker).then((res) => {
                  setCallSettings(res);
                 });
               
                setShowDialer(false);
              }}
              phoneNumber={dialerNumber}
              setPhoneNumber={setDialerNumber}
            />
          )}
        </Wrapper>
      </ContentRow>
    )
  );
};

export default RecordingPlayBack;

const ContentRow = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 28px;
  margin: 22px auto 0;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
    padding: 0 16px;
  }
`;

const Wrapper = styled.div`
  width: 38%;
  min-width: 380px;
  max-width: 520px;
  height: 189px;
  flex-shrink: 0;
  border-radius: 20px;
  background: #adcfd4;

  @media (max-width: 900px) {
    width: 100%;
    min-width: 0;
    max-width: none;
  }
`;

const OrganizationInfoCard = styled.div`
  flex: 1 1 auto;
  width: 60%;
  min-width: 520px;
  max-width: 720px;
  background: #fff;
  border: 1px solid #dbe4e6;
  border-radius: 20px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04);
  padding: 22px;

  @media (max-width: 900px) {
    width: 100%;
    min-width: 0;
    max-width: none;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 22px;
`;

const HeaderIcon = styled.span`
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #edf5f5;
  color: #0796a8;
  font-size: 25px;
`;

const HeaderText = styled.span`
  color: #00323b;
  font-family: "Space Grotesk";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 3px;
  text-transform: uppercase;
`;

const InfoList = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 12px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const InfoTile = styled.div`
  min-height: 92px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border: 1px solid #dfe7ea;
  border-radius: 10px;
  background: #fbfcfc;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  border-bottom: 1px solid #dfe7ea;
  padding: 16px 0;
  &:last-child {
    border-bottom: none;
    padding-bottom: 2px;
  }
`;

const TileIcon = styled.span`
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f0f7f7;
  color: #0796a8;
  font-size: 22px;
`;

const RowIcon = styled.span`
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #edf5f5;
  color: #00323b;
  font-size: 25px;
`;

const InfoContent = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

const Label = styled.span`
  color: #63878d;
  font-family: "Space Grotesk";
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
`;

const Value = styled.span`
  color: #00323b;
  font-family: "Space Grotesk";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.4;
  overflow-wrap: anywhere;
`;

const DescriptionValue = styled(Value)`
  padding: 12px 14px;
  border: 1px solid #dfe7ea;
  border-radius: 10px;
  background: #f7fafa;
`;

const Recording = styled.audio`
  flex-shrink: 0;
  border-radius: 20px;
`;
const Heading = styled.span`
  color: #00323b;
  font-family: "Space Grotesk";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 3.5px;
`;
const DetailsSpan = styled.span`
  color: #fff;
  font-family: "Space Grotesk";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
`;
